// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"index_inputContainer__3jmGZ","passMessage":"index_passMessage__12Ea-","lateral":"index_lateral__2FCR2"};